import { render } from "./top_header.vue?vue&type=template&id=0f0d2204"
import script from "./top_header.vue?vue&type=script&lang=js"
export * from "./top_header.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__